export const getPercentDisplayValue = (value: string): string | null => {
  const numValue = parseFloat(value);

  if (isNaN(numValue)) {
    return null;
  }

  return `${numValue.toFixed(2)}%`;
};
